import { createSelector } from "reselect";
import { selectPrepJob } from "./selectPrepJob";
import { PrepJobResponseStatus } from "@deliverr/prep-service-client";

export const selectIsPrepJobArchived = createSelector(selectPrepJob, (prepJob): boolean => {
  return Boolean(prepJob && prepJob.status === PrepJobResponseStatus.ARCHIVED);
});
